import { useMutation } from '@tanstack/react-query';

import * as LoyaltyService from '~/services/LoyaltyService';

export function useGenerateAdminEsimPromo() {
  return useMutation({
    mutationFn: LoyaltyService.generateAdminEsimPromo,
  });
}
